import { render, staticRenderFns } from "./StationInfoCard.vue?vue&type=template&id=06552d45&scoped=true"
import script from "./StationInfoCard.vue?vue&type=script&lang=js"
export * from "./StationInfoCard.vue?vue&type=script&lang=js"
import style0 from "./StationInfoCard.vue?vue&type=style&index=0&id=06552d45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06552d45",
  null
  
)

export default component.exports